import { useState, useEffect } from 'react';
import '../App.css';

function USARouletteInfo() {

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [hidden, isHidden] = useState(false);

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    useEffect(() => {
        if (getWindowDimensions().width < 1156) {
            isHidden(true)
        } else {
            isHidden(false)
        }

        if (getWindowDimensions().width > 1156) {
            isHidden(false)
        }
    }, [windowDimensions]);

    return (
        <div className='infoBlock'>
            <div className='flex justify-between'>
                <p className='infoBlockTitle'>American roulette</p>
                {
                    getWindowDimensions().width < 1156
                        ? <svg onClick={e => isHidden(!hidden)} width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4035 0.5 25 6.09644 25 13C25 19.9035 19.4035 25.5 12.5 25.5C5.59644 25.5 0 19.9035 0 13ZM10.5114 11.8636C10.5114 11.236 11.0201 10.7273 11.6477 10.7273H13.3523C13.9799 10.7273 14.4886 11.236 14.4886 11.8636V19.8182C14.4886 20.4458 13.9799 20.9545 13.3523 20.9545H11.6477C11.0201 20.9545 10.5114 20.4458 10.5114 19.8182V11.8636ZM14.7727 7.31818C14.7727 6.06299 13.7552 5.04545 12.5 5.04545C11.2448 5.04545 10.2273 6.06299 10.2273 7.31818C10.2273 8.57338 11.2448 9.59091 12.5 9.59091C13.7552 9.59091 14.7727 8.57338 14.7727 7.31818Z" fill="#0E96FF" />
                        </svg>
                        : ''
                }

            </div>


            {
                hidden === false
                    ? <div className="infoBlockItems">
                        <div className="infoBlockItem">
                            <p>1.</p>
                            <p>Place your chips on the table (as many as you like)</p>
                        </div>
                        <div className="infoBlockItem">
                            <p>2.</p>
                            <p>Pick the number the wheel will land on or click spin for a random generated number</p>
                        </div>
                        <div className="infoBlockItem">
                            <p>3.</p>
                            <p>Table will show the outcomes based on the result</p>
                        </div>
                        <div className='smallTextBlock'>
                            <p className='smallText'>(Profits shown do not include original stake.)</p>
                        </div>
                    </div>
                    : null
            }
        </div>
    );
}

export default USARouletteInfo;